/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	
	const newsTagChange = () => {
		$('.js-sortBtn').on('click', (e) => {
			let $this = $(e.currentTarget);
			let thisTag = $this.attr('data-tag');
			$('.js-sortItem').removeClass('is-hidden');

			if($this.hasClass(a)) {
				$this.removeClass(a);
			} else {
				$('.js-sortBtn').removeClass(a);
				$this.addClass(a);
				$('.js-sortItem').each((idx,ele) => {
					if($(ele).find('.js-tag .rt_cf_nt_code').text() !== thisTag) {
						$(ele).addClass('is-hidden');
					}
				});
			}
		});
	};

	newsTagChange();

})(window.jQuery, window.FUNCTIONS);
